import { EMAIL_REGEX } from '../../config/globals';

export const getEmailRegisterOptions = (enableEmailValidation: () => void) => ({
  setValueAs: (value: string) => value.replaceAll(/\s/g, ''),
  required: 'Email.error.required',
  pattern: {
    value: new RegExp(EMAIL_REGEX),
    message: 'Email.error.pattern',
  },
  onBlur: enableEmailValidation,
});
